import {
	UserTemplateChannelsEnum,
	UserTemplateStatusEnum,
	UserTemplateTypeEnum,
} from './constants/index';
import { StorytellerType } from '@app/redux/storyteller/types';
import createFetchTypes from '@app/utils/createFetchTypes';

export type UserTemplateType = {
	body: string;
	channel: UserTemplateChannelsEnum;
	createdAt: string;
	createdBy: StorytellerType;
	id: string;
	location: string;
	status: UserTemplateStatusEnum;
	teams: string[];
	title: string;
	type: UserTemplateTypeEnum;
	default: boolean;
	updatedAt: string;
	workspace: string;
	_id: string;
};

const mainType = 'userTemplates';

export const getUserTemplatesTypes = createFetchTypes(
	`${mainType}_GET_USER_TEMPLATES`,
);

// Handles the sms template creation and update - saves on userTemplates.smsTemplates.templates
export const getSMSUserTemplateTypes = createFetchTypes(
	`${mainType}_GET_SMS_USER_TEMPLATE`,
);

// Handles the whatsapp template creation and update - saves on userTemplates.waTemplates.templates
export const getWhatsappUserTemplateTypes = createFetchTypes(
	`${mainType}_GET_WHATSAPP_USER_TEMPLATE`,
);

export const createTemplatesTypes = createFetchTypes(
	`${mainType}_CREATE_USER_TEMPLATE`,
);

export const updateTemplatesTypes = createFetchTypes(
	`${mainType}_UPDATE_USER_TEMPLATE`,
);

export const updateTeamsOnUserTemplateTypes = createFetchTypes(
	`${mainType}_UPDATE_TEAMS_ON_USER_TEMPLATE`,
);

export const deleteTemplatesTypes = createFetchTypes(
	`${mainType}_DELETE_USER_TEMPLATE`,
);
